// Türkiye şehirleri ve ilçeleri
export const turkeyData = {
  "İstanbul": ["Kadıköy", "Beşiktaş", "Üsküdar", "Şişli", "Beyoğlu", "Fatih", "Bakırköy", "Ataşehir", "Maltepe", "Kartal", "Pendik", "Tuzla", "Sarıyer", "Beykoz", "Çekmeköy", "Sancaktepe", "Ümraniye", "Sultanbeyli", "Başakşehir", "Esenyurt", "Avcılar", "Küçükçekmece", "Bahçelievler", "Bağcılar", "Güngören", "Esenler", "Bayrampaşa", "Eyüpsultan", "Gaziosmanpaşa", "Kağıthane", "Arnavutköy", "Büyükçekmece", "Çatalca", "Silivri", "Beylikdüzü", "Zeytinburnu", "Adalar", "Şile"],
  "Ankara": ["Çankaya", "Keçiören", "Mamak", "Yenimahalle", "Etimesgut", "Sincan", "Altındağ", "Pursaklar", "Gölbaşı", "Polatlı", "Beypazarı", "Çubuk", "Kahramankazan", "Akyurt", "Elmadağ", "Haymana", "Bala", "Şereflikoçhisar", "Ayaş", "Güdül", "Kızılcahamam", "Nallıhan", "Evren", "Kalecik", "Çamlıdere"],
  "İzmir": ["Konak", "Karşıyaka", "Bornova", "Buca", "Bayraklı", "Çiğli", "Gaziemir", "Karabağlar", "Balçova", "Narlıdere", "Güzelbahçe", "Urla", "Çeşme", "Seferihisar", "Menderes", "Torbalı", "Kemalpaşa", "Aliağa", "Menemen", "Foça", "Bergama", "Dikili", "Kınık", "Kiraz", "Beydağ", "Ödemiş", "Tire", "Bayındır", "Selçuk"],
  "Bursa": ["Osmangazi", "Yıldırım", "Nilüfer", "Gürsu", "Kestel", "Mudanya", "Gemlik", "İnegöl", "Orhangazi", "İznik", "Karacabey", "Mustafakemalpaşa", "Yenişehir", "Keles", "Orhaneli", "Büyükorhan", "Harmancık"],
  "Antalya": ["Muratpaşa", "Kepez", "Konyaaltı", "Döşemealtı", "Aksu", "Serik", "Manavgat", "Alanya", "Gazipaşa", "Kemer", "Kumluca", "Finike", "Demre", "Kaş", "Elmalı", "Korkuteli", "Akseki", "İbradı", "Gündoğmuş"],
  "Adana": ["Seyhan", "Yüreğir", "Çukurova", "Sarıçam", "Ceyhan", "Kozan", "İmamoğlu", "Karaisalı", "Pozantı", "Aladağ", "Feke", "Saimbeyli", "Tufanbeyli", "Yumurtalık", "Karataş"],
  "Konya": ["Selçuklu", "Meram", "Karatay", "Ereğli", "Akşehir", "Beyşehir", "Seydişehir", "Cihanbeyli", "Kulu", "Çumra", "Karapınar", "Ilgın", "Kadınhanı", "Sarayönü", "Yunak", "Bozkır", "Hadim", "Taşkent", "Ahırlı", "Güneysınır", "Hüyük", "Derebucak", "Doğanhisar", "Altınekin", "Tuzlukçu", "Emirgazi", "Halkapınar", "Yalıhüyük", "Çeltik", "Derbent"],
  "Gaziantep": ["Şahinbey", "Şehitkamil", "Oğuzeli", "Nizip", "İslahiye", "Nurdağı", "Araban", "Yavuzeli", "Karkamış"],
  "Mersin": ["Akdeniz", "Mezitli", "Toroslar", "Yenişehir", "Tarsus", "Erdemli", "Silifke", "Anamur", "Mut", "Gülnar", "Aydıncık", "Bozyazı", "Çamlıyayla"],
  "Diyarbakır": ["Bağlar", "Kayapınar", "Sur", "Yenişehir", "Bismil", "Ergani", "Silvan", "Çermik", "Çınar", "Dicle", "Eğil", "Hani", "Hazro", "Kocaköy", "Kulp", "Lice"],
  "Kayseri": ["Melikgazi", "Kocasinan", "Talas", "Hacılar", "İncesu", "Develi", "Yahyalı", "Bünyan", "Pınarbaşı", "Sarıoğlan", "Tomarza", "Yeşilhisar", "Akkışla", "Felahiye", "Özvatan", "Sarız"]
};

export const facilityFeatures = [
  { id: 'otopark', label: 'Otopark', icon: '🅿️' },
  { id: 'wifi', label: 'WiFi', icon: '📶' },
  { id: 'kafeterya', label: 'Kafeterya', icon: '☕' },
  { id: 'dus', label: 'Duş', icon: '🚿' },
  { id: 'soyunma_odasi', label: 'Soyunma Odası', icon: '🚪' },
  { id: 'aydinlatma', label: 'Aydınlatma', icon: '💡' },
  { id: 'tribun', label: 'Tribün', icon: '🏟️' },
  { id: 'kamera', label: 'Kamera Kaydı', icon: '📹' },
  { id: 'top', label: 'Top Kiralama', icon: '⚽' },
  { id: 'krampon', label: 'Krampon Kiralama', icon: '👟' },
  { id: 'forma', label: 'Forma Kiralama', icon: '👕' },
  { id: 'hakem', label: 'Hakem Hizmeti', icon: '🧑‍⚖️' },
];

export const sportBranches = [
  { id: 'futbol', label: 'Futbol', icon: '⚽' },
  { id: 'basketbol', label: 'Basketbol', icon: '🏀' },
  { id: 'voleybol', label: 'Voleybol', icon: '🏐' },
  { id: 'tenis', label: 'Tenis', icon: '🎾' },
  { id: 'badminton', label: 'Badminton', icon: '🏸' },
  { id: 'yuzme', label: 'Yüzme', icon: '🏊' },
  { id: 'fitness', label: 'Fitness', icon: '🏋️' },
  { id: 'masa_tenisi', label: 'Masa Tenisi', icon: '🏓' },
];

// Surface types for facilities
export const surfaceTypes = [
  { id: 'suni_cim', label: 'Suni Çim', icon: '🌱' },
  { id: 'dogal_cim', label: 'Doğal Çim', icon: '🌿' },
  { id: 'parke', label: 'Parke', icon: '🪵' },
  { id: 'kaucuk', label: 'Kauçuk', icon: '⬛' },
  { id: 'beton', label: 'Beton', icon: '🧱' },
  { id: 'tartan', label: 'Tartan', icon: '🔴' },
];

// Common field sizes
export const fieldSizes = [
  { id: '20x30', label: '20x30m (Küçük)' },
  { id: '25x40', label: '25x40m (Orta)' },
  { id: '25x45', label: '25x45m (Standart)' },
  { id: '30x50', label: '30x50m (Büyük)' },
  { id: '40x60', label: '40x60m (Profesyonel)' },
];

// Capacity options
export const capacityOptions = [
  { id: 10, label: '10 Kişi (5+5)' },
  { id: 12, label: '12 Kişi (6+6)' },
  { id: 14, label: '14 Kişi (7+7)' },
  { id: 16, label: '16 Kişi (8+8)' },
  { id: 20, label: '20 Kişi (10+10)' },
  { id: 22, label: '22 Kişi (11+11)' },
];

// Şehir listesi
export const cities = Object.keys(turkeyData);

// İlçe getir
export const getDistricts = (city) => {
  return turkeyData[city] || [];
};
